import { combineReducers } from 'redux';
//import * as redditReducers from "./reddit";
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import autoComplete from './autoComplete';
import cart from './cart';
import orderSummary from './orderSummary';
import shippingRate from './shippingRate';
import shippingForm from './shippingForm';
import noArticleModal from './noArticleModal'
import announcement from './announcement'
import voucher from './voucher'
import ticket from './ticket';
import error from './error';
import status from './status';
import orders from './orders';
// import { reducer as reduxAsyncConnect } from 'redux-connect';
// import { reducer as formReducer} from 'redux-form';

const rootReducer = combineReducers({
  // reduxAsyncConnect,
  autoComplete,
  cart,
  orderSummary,
  shippingRate,
  error,
  form: formReducer.plugin({
    shipping: shippingForm
  }),
  routing: routerReducer,
  ticket,
  noArticleModal,
  voucher,
  announcement,
  status,
  orders
  // form: formReducer,
});

export default rootReducer;